import { React, useState, useEffect, useContext, useMemo, useRef } from "react";
import { AppContext } from '../../../../AppStore';
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";

const MOB_MachineInspect = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [selectDate, setSelectDate] = useState(appStore.YYYY_MM_DD());
    const [machineOption, setMachineOption] = useState([]);
    const [machineId, setMachineId] = useState('');
    const [dataRows, setDataRows] = useState([]);
    const dirtyRef = useRef({});

    useEffect(() => {
        appStore.setLoading(true);
        const accessList = JSON.parse(localStorage.getItem("nav"));
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        } else {
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer: 5000,
                timerProgressBar: true
            }).then(() => {
                const main = localStorage.getItem("main") || "/m";
                return navigate(main, { replace: true });
            });
        }
        appStore.setLoading(false);
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            axios.get('/api/SelectCommon/MachineList')
            .then((response) => {
                const optionArray = response.data.map((item) =>
                    ({ value: String(item.machine_id), label: item.machine_name })
                );
                const next = [ ...new Set((optionArray).map(JSON.stringify)) ].map(JSON.parse);
                setMachineOption(next);
                if (next.length > 0 && !machineId) {
                    setMachineId(String(next[0].value));
                }
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }, [MenuID]);

    useEffect(() => {
        if (!machineId || !selectDate) return;
        handleSearch();
    }, [machineId, selectDate]);

    const normalizeCycleType = (value) => {
        const ct = String(value ?? '').trim().toUpperCase();
        return ct === 'W' || ct === 'M' ? ct : 'D';
    };

    const buildWeekRanges = (monthString) => {
        const m = Moment(monthString, 'YYYY-MM', true);
        const base = m.isValid() ? m : Moment();
        const days = base.daysInMonth();
        const ranges = [];
        let start = 1;
        while (start <= days) {
            const dow = base.clone().date(start).isoWeekday(); // 1=월 ... 7=일
            const span = Math.min(days - start + 1, 8 - dow);
            ranges.push({ start, span });
            start += span;
        }
        return ranges;
    };

    const buildPivotRows = (raw, monthString) => {
        const m = Moment(monthString, 'YYYY-MM', true);
        const base = m.isValid() ? m : Moment();
        const days = base.daysInMonth();
        const monthStart = base.clone().startOf('month');
        const monthEnd = base.clone().endOf('month');
        const map = new Map();

        raw.forEach(r => {
            const key = r.inspect_id || r.inspect_text;
            if (!map.has(key)) {
                map.set(key, {
                    id: `p-${key}`,
                    inspect_id: r.inspect_id ?? 0,
                    cycle_type: normalizeCycleType(r.cycle_type),
                    inspect_text: r.inspect_text ?? '',
                    statusMap: {}
                });
            }

            const start = Moment(r.start_date, 'YYYY-MM-DD', true);
            const end = Moment(r.end_date, 'YYYY-MM-DD', true);
            if (!start.isValid() || !end.isValid()) {
                return;
            }
            if (start.isAfter(monthEnd, 'day') || end.isBefore(monthStart, 'day')) {
                return;
            }

            const rangeStart = start.isBefore(monthStart, 'day') ? monthStart.clone() : start.clone();
            const rangeEnd = end.isAfter(monthEnd, 'day') ? monthEnd.clone() : end.clone();
            const row = map.get(key);
            for (let d = rangeStart.date(); d <= rangeEnd.date(); d++) {
                row.statusMap[d] = r.status || '';
            }
        });

        return Array.from(map.values()).map(row => {
            const dayObj = {};
            for (let d = 1; d <= days; d++) {
                dayObj[`day${d}`] = row.statusMap[d] || '';
            }
            return { ...row, ...dayObj };
        });
    };

    const handleSearch = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        const baseMonth = Moment(selectDate, 'YYYY-MM-DD', true).isValid()
            ? Moment(selectDate).format('YYYY-MM')
            : Moment().format('YYYY-MM');
        dirtyRef.current = {};

        axios.get('/api/p/MachineInspect/DataList',
            {
                params : {
                    machine_id : machineId,
                    base_month : baseMonth
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            const array = (response.data || []).map((item, index) => ({
                id: `${item.machine_id || machineId}-${item.inspect_id || index}-${item.start_date || item.end_date || index}`,
                inspect_id: item.inspect_id ?? 0,
                inspect_text: item.inspect_text ?? '',
                cycle_type: normalizeCycleType(item.cycle_type),
                start_date: item.start_date ?? '',
                end_date: item.end_date ?? '',
                status: item.status ?? ''
            }));
            setDataRows(buildPivotRows(array, baseMonth));
        })
        .catch((error) => {
            setDataRows(buildPivotRows([], baseMonth));
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });
    };

    const listItems = useMemo(() => {
        const base = Moment(selectDate, 'YYYY-MM-DD', true);
        if (!base.isValid()) {
            return [];
        }
        const baseMonth = base.format('YYYY-MM');
        const days = base.daysInMonth();
        const day = base.date();
        const weekRanges = buildWeekRanges(baseMonth);
        const week = weekRanges.find(r => day >= r.start && day < r.start + r.span);
        return dataRows.map((row) => {
            const ct = normalizeCycleType(row.cycle_type);
            if (ct === 'D') {
                return {
                    inspect_id: row.inspect_id,
                    inspect_text: row.inspect_text,
                    cycle_type: ct,
                    value: row[`day${day}`] || '',
                    start: day,
                    end: day
                };
            }
            if (ct === 'W' && week) {
                let value = '';
                for (let d = week.start; d < week.start + week.span; d++) {
                    const v = row[`day${d}`];
                    if (v) {
                        value = v;
                        break;
                    }
                }
                return {
                    inspect_id: row.inspect_id,
                    inspect_text: row.inspect_text,
                    cycle_type: ct,
                    value,
                    start: week.start,
                    end: week.start + week.span - 1
                };
            }
            if (ct === 'M') {
                let value = '';
                for (let d = 1; d <= days; d++) {
                    const v = row[`day${d}`];
                    if (v) {
                        value = v;
                        break;
                    }
                }
                return {
                    inspect_id: row.inspect_id,
                    inspect_text: row.inspect_text,
                    cycle_type: ct,
                    value,
                    start: 1,
                    end: days
                };
            }
            return null;
        }).filter(Boolean);
    }, [dataRows, selectDate]);

    const updateItemValue = (item, value) => {
        const key = String(item.inspect_id);
        dirtyRef.current = { ...dirtyRef.current, [key]: true };
        const baseMonth = Moment(selectDate, 'YYYY-MM-DD', true).isValid()
            ? Moment(selectDate).format('YYYY-MM')
            : Moment().format('YYYY-MM');
        const days = Moment(baseMonth, 'YYYY-MM', true).daysInMonth();

        setDataRows(prev => prev.map(r => {
            if (r.inspect_id !== item.inspect_id) return r;
            const updated = { ...r };
            if (item.cycle_type === 'D') {
                updated[`day${item.start}`] = value;
            } else if (item.cycle_type === 'W') {
                for (let d = item.start; d <= item.end; d++) {
                    updated[`day${d}`] = value;
                }
            } else if (item.cycle_type === 'M') {
                for (let d = 1; d <= days; d++) {
                    updated[`day${d}`] = value;
                }
            }
            return updated;
        }));
    };

    const handleSave = () => {
        const base = Moment(selectDate, 'YYYY-MM-DD', true);
        if (!base.isValid()) {
            Swal.fire({ title: '저장 오류', text: '날짜를 확인해주세요.', icon: 'error', confirmButtonText: '확인' });
            return;
        }
        const baseMonth = base.format('YYYY-MM');
        const pad = (n) => String(n).padStart(2, '0');
        const rows = listItems
            .filter(item => dirtyRef.current[String(item.inspect_id)])
            .map((item) => ({
                machine_id: machineId,
                inspect_id: item.inspect_id,
                start_date: `${baseMonth}-${pad(item.start)}`,
                end_date: `${baseMonth}-${pad(item.end)}`,
                status: item.value || '',
                delete_yn: item.value ? 'N' : 'Y'
            }));

        if (rows.length === 0) {
            Swal.fire({ title: '저장 안내', text: '변경된 항목이 없습니다.', confirmButtonText: '확인' });
            return;
        }

        if (appStore.loading) return;
        appStore.setLoading(true);
        axios.post('/api/p/MachineInspect/DataSave', {
            machine_id: machineId,
            base_month: baseMonth,
            rows
        }, { withCredentials: true })
        .then(() => {
            handleSearch();
            Swal.fire({
                title: '저장 완료',
                text: '설비점검 정보가 정상적으로 저장되었습니다.',
                confirmButtonText: '확인',
            });
        })
        .catch((error) => {
            console.log(error);
            appStore.capture();
            Swal.fire({
                title: '저장 실패',
                text: '저장 중 오류가 발생했습니다. 관리자에게 문의해주세요.',
                confirmButtonText: '확인',
            });
        })
        .finally(() => {
            appStore.setLoading(false);
        });
    };

    return (
        <div style={{ width: '100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' }}>
            <div className="M_menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div style={{ float: 'right' }}>
                        <Button
                            onClick={handleSave}
                            className="M_btn-p"
                            sx={{
                                m: 1,
                                fontSize: 15,
                                color: "white",
                                borderColor: "#FF3636",
                                backgroundColor: "#FF3636",
                                ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                            }}
                            variant="outlined">
                            저장
                        </Button>
                    </div>
                </div>
            </div>

            <div className="M_contents" style={{ overflow: 'hidden' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px', marginTop: '5px' }}>
                    <input
                        type="date"
                        value={selectDate || ''}
                        onChange={(e) => setSelectDate(e.target.value)}
                        style={{
                            flex: 1,
                            WebkitAppearance: 'none',
                            appearance: 'none',
                            backgroundColor: '#fff',
                            border: '1px solid #d1d5db',
                            borderRadius: 4,
                            padding: '6px 8px',
                            minHeight: 36
                        }}
                    />
                    <select
                        value={machineId}
                        onChange={(e) => setMachineId(e.target.value)}
                        style={{
                            flex: 1,
                            backgroundColor: '#fff',
                            border: '1px solid #d1d5db',
                            borderRadius: 4,
                            padding: '6px 8px',
                            minHeight: 36
                        }}
                    >
                        {machineOption.map((item) => (
                            <option key={`m-${item.value}`} value={item.value}>{item.label}</option>
                        ))}
                    </select>
                </div>

                <div style={{ maxHeight: 'calc(100vh - 155px)', overflowY: 'auto' }}>
                    {listItems.length === 0 ? (
                        <p style={{ textAlign: 'center', color: '#aaa' }}>점검항목이 없습니다.</p>
                    ) : (
                        listItems.map((item) => (
                            <div
                                key={`mi-${item.inspect_id}-${item.cycle_type}`}
                                style={{
                                    backgroundColor: '#fff',
                                    borderBottom: '1px solid #eee',
                                    padding: '8px 10px',
                                    fontSize: '14px'
                                }}
                            >
                                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap: 8 }}>
                                    <div style={{ fontWeight: 'bold', minWidth: 52 }}>
                                        {item.cycle_type === 'D' ? '일일' : item.cycle_type === 'W' ? '주간' : '월간'}
                                    </div>
                                    <div style={{ flex: 1, fontSize: '15px', color: '#222' }}>
                                        {item.inspect_text}
                                    </div>
                                    <select
                                        value={item.value || ''}
                                        onChange={(e) => updateItemValue(item, e.target.value)}
                                        style={{ width: 70 }}
                                    >
                                        <option value=""></option>
                                        <option value="O">O</option>
                                        <option value="T">△</option>
                                        <option value="X">X</option>
                                    </select>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default MOB_MachineInspect;
